//import Asset from "./asset";
import ApiHome from "../../utils/api.home";

//import AuthService from "../../utils/auth.service"

class Asset {
  constructor(
    p5,
    x,
    y,
    img,
    local_image,
    asset_name,
    asset_line,
    name,
    sizeX,
    sizeY,
    anglee,
    speed = 0.0,
    history
  ) {
    this.myHistory = history;
    this.INITIAL_SPEED = speed + 0;
    this.INITIAL_ANGLEE = anglee;
    this.name = name;
    this._p5 = p5;
    this.img = img;
    this.local_image = local_image;
    this.asset_name = asset_name;
    this.asset_line = asset_line;
    this.posX = x * this._p5.cos(this._p5.radians(anglee));
    this.posY = y * this._p5.sin(this._p5.radians(anglee));
    this.y = y;
    this.sizeX = sizeX;
    this.sizeY = sizeY;
    this.anglee = anglee;
    this.speed = speed + 0.0;
  }

  _getDistance() {
    return this._p5.dist(
      this._p5.mouseX,
      this._p5.mouseY,
      this.posX,
      this.posY
    );
  }

  show() {
    //let fullName = this.name.split("/");
    //this.posX = this.posX - this.speed;

    /*
    if (this.speed) {
      if (this.posX < -540) {
        this.posX = 1600;
        this.posY = this.y - 160;
      } else if (this.posX >= 1600) {
        this.posX = -540;
        this.posY = this.y - 160;
      } else if (this.posX < 400) {
        this.posY = this.posY - 0.1 * 0.7;
      } else if (this.posX > 400 && this.posX < 600) {
        this.posY = this.posY - 0.06 * 0.7;
      } else if (this.posX > 800 && this.posX < 900) {
        this.posY = this.posY + 0.06 * 0.7;
      } else {
        this.posY = this.posY + 0.1 * 0.7;
      }
    }*/

    this._p5.image(this.img, this.posX, this.posY, this.sizeX, this.sizeY);
    //this._p5.text(
    //  //fullName[fullName.length - 1],
    //  this.asset_name,
    //  this.posX + this.sizeX / 2.5,
    //  this.posY - 5
    //);
    //this.anglee += this.speed;
    this._p5.fill(200);
    this._p5.textSize(14);
  }

  clicked() {
    if (this._getDistance() < this.sizeY && !window.modalOpen) {
      //let assetline = "";
      //this.name.split("/").forEach(e => (assetline += "," + e.toLowerCase()));
      //assetline = this.asset_line;

      this.myHistory.push(`/assets/?assetline=${this.asset_line}`, {});
    }
  }

  hover(stop) {
    if (this.isHover() || stop) {
      this._p5.cursor(this._p5.HAND);
      this.speed = 0;
    } else {
      this._p5.cursor(null);
      this.speed = this.INITIAL_SPEED;
    }

    return this.isHover();
  }

  isHover() {
    return this._getDistance() < this.sizeX;
  }

  drag(speed) {
    this.speed = speed;
  }
}

export default function sketch(p) {
  const FRAMES = 60;
  let logo, bkg;
  let previousX;
  let assets = [];
  let history = {};
  let alfa = 255;
  let timer = 15 * FRAMES;
  let counter = 0;
  let stopped = false;

  p.myCustomRedrawAccordingToNewPropsHandler = function(props) {
    if (props.history) {
      history = props.history;
    }
  };

  let addAsset = function(x, y, img, local_image, asset_name, asset_line, name, sizeX, sizeY, angl, speed = 0.01) {

    let image = p.loadImage(img, 'png');

    //let image = p.loadImage("assets/images/logo-drums-plate.jpg");
    assets.push(
      new Asset(p, x, y, image, local_image, asset_name, asset_line, name, sizeX, sizeY, angl, speed, history)
    );
  };

  p.setup = async function() {
    p.createCanvas(window.innerWidth, window.innerHeight);
    p.frameRate(FRAMES);

    p.background(0);
    logo = p.loadImage("assets/images/logo-drums-plate.jpg");
    bkg = p.loadImage("assets/images/cta-background.jpg");


    let company_code = localStorage.getItem("company_code");

    await new ApiHome().get(company_code).then(response => {
      if (response.data) {
        let assets = response.data;

        console.log(assets);

        assets.forEach(asset => {

          if (asset.speed > 0) {
              addAsset(
                  asset.x,
                  asset.y,
                  asset.img_url,
                  asset.local_image,
                  asset.asset_name,
                  asset.asset_line,
                  asset.name,
                  asset.sizeX,
                  asset.sizeY,
                  asset.anglee,
                  asset.speed
              );
          }
        });

        console.log(assets);
      }
    });
  };

  p.mousePressed = function(event) {
    previousX = event.x;

    assets.forEach(asset => {
      if (asset.isHover()) {
        this.clickedClasset = asset.name;
      }
    });
  };

  p.mouseReleased = function(event) {
    if (event) {
      assets.forEach(asset => {
        if (asset.isHover() && this.clickedClasset === asset.name) {
          asset.clicked();
        }
      });
    }
  };

  p.mouseDragged = function(event) {
    const x = event.x;
    let speed = 0;
    let aditional = 0;

    if (x < previousX) {
      aditional = (previousX - x) / 30;
      speed = 5 + aditional;
    } else if (x > previousX) {
      aditional = (x - previousX) / 30;
      speed = -5 - aditional;
    }

    if (x !== previousX) {
      assets.forEach(asset => {
        asset.drag(speed);
      });
    }
  };

  p.draw = function() {
    p.image(bkg, 0, 60, window.innerWidth, window.innerHeight);

    assets.forEach(asset => {
      asset.show();
    });

    let mustStop = false;
    assets.forEach(asset => {
      if (asset.hover(stopped)) {
        mustStop = true;
      }
    });

    if (mustStop) {
      stopped = true;
    } else {
      stopped = false;
    }

    if (counter <= timer) {
      p.textSize(50);
      p.fill(200, 200, 200, alfa);
      p.text("Winvite.io", 30, 130);
      p.tint(alfa, alfa, alfa);
      p.image(logo, 320, 97, 40, 40);
      p.noTint();
      p.textSize(16);
      p.text("Here you can have amazing experiences!", 30, 100 + 20 * 3);
      p.text("Choose your favorite show...", 30, 100 + 20 * 4);
      p.textSize(14);
      p.fill(200, 200, 200, 255);
    }

    alfa = alfa - 0.002 * counter;
    counter++;
  };
}



// WEBPACK FOOTER //
// ./src/containers/PlanetsPage/sketch.js